import { create } from "zustand";
import { persist } from "zustand/middleware";

const useAuthStore = create(
  persist(
    (set, get) => ({
      isLogin: false,
      currentUser: {},
      setCurrentUser: (user, login) => {
        if (user && login) {
          set({ currentUser: user, isLogin: login });
        } else {
          set({ currentUser: {}, isLogin: false });
        }
      },
      logout: () => {
        set({ currentUser: {}, isLogin: false });
      },
      getToken: () => {
        const user = get().currentUser;
        return user?.access_token || null;
      },
    }),
    {
      name: "auth-storage",
    }
  )
);

export default useAuthStore;
